import React, { useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import api from '../config/api';
import SEO from '../components/SEO';
import './help.css';
import { BRAND } from '../config/brand';

const LABELS = {
  // '3d-tours' : '3D‑туры',
  'registrazia': 'Регистрация',
  'creation': 'Создание',
  // Legacy sections removed from the domain:
  // boards, tags, pins
  'policy': 'Политика',
  'account': 'Аккаунт',
  'community': 'Сообщество',
  'uslugi': 'Услуги и тарифы',
  'support': 'Поддержка',
  'legal': 'Право'
};

export default function HelpSection() {
  const { section = '' } = useParams();
  const { data, isLoading, error } = useQuery([
    'help-section', section
  ], async () => {
    const res = await api.get(`/api/pages/help-section/${encodeURIComponent(section)}`);
    return res?.data || null;
  }, { enabled: !!section, staleTime: 60 * 1000 });

  const label = useMemo(() => LABELS[String(section).toLowerCase()] || section, [section]);
  const title = `${label} — Справка ${BRAND.name}`;
  const description = `Статьи раздела «${label}».`;
  const canonical = `${BRAND.baseUrl}/help/${encodeURIComponent(section)}`;

  return (
    <div className="min-h-screen bg-secondary-50">
      <SEO
        title={title}
        description={description}
        canonical={canonical}
        url={canonical}
        type="website"
        structuredData={[]}
        noindex={false}
      />

      <div className="max-w-4xl mx-auto px-4 py-10">
        <header className="mb-6">
          <h1 className="text-2xl font-bold text-secondary-900">{label}</h1>
          <div className="text-sm text-secondary-600">Справка {BRAND.name}</div>
        </header>

        {isLoading ? (
          <div className="p-8 flex items-center justify-center">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-500" />
          </div>
        ) : error ? (
          <div className="p-6 text-center text-red-600">Не удалось загрузить статьи раздела</div>
        ) : !data || !Array.isArray(data.pages) || data.pages.length === 0 ? (
          <div className="p-6 text-secondary-700">В этом разделе пока нет статей.</div>
        ) : (
          <ul className="space-y-3">
            {data.pages.map((p) => (
              <li key={p.slug} className="bg-white border border-secondary-200 rounded-lg p-4 shadow-sm">
                <Link className="text-base font-semibold link" to={p.url}>{p.title}</Link>
                {p.description && (
                  <p className="text-sm text-secondary-700 mt-1">{p.description}</p>
                )}
              </li>
            ))}
          </ul>
        )}

        <div className="mt-8">
          <Link className="link" to="/help">← Назад к разделам</Link>
        </div>
      </div>
    </div>
  );
}
